import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LoginPage } from "@/pages/LoginPage";
import { Dashboard } from "@/pages/Dashboard";
import { CarsPage } from "@/pages/CarsPage";
import { CarDetail } from "@/pages/CarDetail";
import { TripsPage } from "@/pages/TripsPage";
import { ReportsPage } from "@/pages/ReportsPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { UsersPage } from "@/pages/UsersPage";
import { PublicSite } from "@/pages/PublicSite";
import { SiteAdminPage } from "@/pages/SiteAdminPage";
import { AppShell } from "@/components/AppShell";
import { Toaster } from "@/components/ui/sonner";

const Protected = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-zinc-500 uppercase tracking-[0.3em] text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return <AppShell>{children}</AppShell>;
};

const RootRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-zinc-500 uppercase tracking-[0.3em] text-sm">Loading…</div>;
  return user ? <Navigate to="/dashboard" replace /> : <PublicSite />;
};

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRoute />} />
            <Route path="/site" element={<PublicSite />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/cars" element={<Protected><CarsPage /></Protected>} />
            <Route path="/cars/:carId" element={<Protected><CarDetail /></Protected>} />
            <Route path="/trips" element={<Protected><TripsPage /></Protected>} />
            <Route path="/reports" element={<Protected><ReportsPage /></Protected>} />
            <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />
            <Route path="/admin/users" element={<Protected adminOnly><UsersPage /></Protected>} />
            <Route path="/admin/site" element={<Protected adminOnly><SiteAdminPage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}
